import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AccessibilityControls, PortfolioState } from '../types/navigation'

interface PortfolioStore extends PortfolioState {
  // Actions
  setCurrentPage: (page: string) => void
  toggleSidePanel: () => void
  setSidePanelVisible: (visible: boolean) => void
  updateAccessibilityControls: (
    controls: Partial<AccessibilityControls>
  ) => void
  toggleDiagramMode: () => void
}

const defaultAccessibilityControls: AccessibilityControls = {
  reducedMotion: false,
  highContrast: false,
  largeText: false,
}

export const usePortfolioStore = create<PortfolioStore>()(
  persist(
    (set, get) => ({
      // Initial state
      currentPage: '/',
      sidePanelVisible: false,
      accessibilityControls: defaultAccessibilityControls,
      diagramMode: false,

      // Actions
      setCurrentPage: (page: string) => {
        set({ currentPage: page })
      },

      toggleSidePanel: () => {
        set({ sidePanelVisible: !get().sidePanelVisible })
      },

      setSidePanelVisible: (visible: boolean) => {
        set({ sidePanelVisible: visible })
      },

      updateAccessibilityControls: (
        controls: Partial<AccessibilityControls>
      ) => {
        set({
          accessibilityControls: {
            ...get().accessibilityControls,
            ...controls,
          },
        })
      },

      toggleDiagramMode: () => {
        set({ diagramMode: !get().diagramMode })
      },
    }),
    {
      name: 'portfolio-store',
      partialize: state => ({
        accessibilityControls: state.accessibilityControls,
        diagramMode: state.diagramMode,
      }),
    }
  )
)
